import {ClassValue} from "clsx";
import cn from "@/utils/cn";

export default function Icon({component: Component, className, ...props}: {component: React.ComponentType<any>, className?: ClassValue})
{
    return <Component className={cn("size-[1.25em]", className)} {...props} />;
}
